import Cookies from 'js-cookie';
import { ONE_DAY_IN_SECONDS, ONE_DAY_IN_MINUTES } from 'cio/utils/time-constants';
import environment from 'cio/config/environment';
import UserModel from 'cio/models/user';

export const AUTH_COOKIE_EXPIRES_IN_DAYS = 7;
export const AUTH_COOKIE_EXPIRES_IN_SECONDS = AUTH_COOKIE_EXPIRES_IN_DAYS * ONE_DAY_IN_SECONDS;

export const ACCESS_COOKIE = '_access'; // bare user access token, needed for auth on back-end HTML pages (receipt details)
export const ACCESS_COOKIE_EXPIRATION = '_access_expiration'; // access token expiration time, needed for checking on every call
export const USER_ID_COOKIE = '_current_user_id'; // bare user access token, needed for auth on back-end HTML pages (receipt details)
export const EMBER_SIMPLE_AUTH_SESSION_COOKIE = 'ember_simple_auth-session'; // ember-simple-auth session data JSON (also containing user access token)
export const TWO_FACTOR_LINK_TOKEN = '_2fa_link_token'; // 2FA link authentication cookie

export function getAccessCookie() {
  return Cookies.get(ACCESS_COOKIE);
}

export function getAccessExpirationCookie() {
  return Cookies.get(ACCESS_COOKIE_EXPIRATION);
}

export function getTwoFactorAuthLinkCookie() {
  return Cookies.get(TWO_FACTOR_LINK_TOKEN);
}

export function setAccessCookie(accessToken: string) {
  return Cookies.set(ACCESS_COOKIE, accessToken, {
    expires: AUTH_COOKIE_EXPIRES_IN_DAYS,
    sameSite: 'strict',
    secure: !environment.isDevelopment,
  });
}

export function setAccountIdCookie(user: UserModel) {
  if (!environment.cookieDomain) {
    return;
  }

  return Cookies.set(USER_ID_COOKIE, user.id, {
    domain: environment.cookieDomain,
    sameSite: 'strict',
    secure: !environment.isDevelopment,
  });
}

export function setAccessExpirationCookie(expirationTime: number) {
  return Cookies.set(ACCESS_COOKIE_EXPIRATION, expirationTime.toString(), {
    sameSite: 'strict',
    secure: !environment.isDevelopment,
  });
}

export function setTwoFactorAuthLinkCookie(token: string) {
  return Cookies.set(TWO_FACTOR_LINK_TOKEN, token, {
    expires: 15 / ONE_DAY_IN_MINUTES,
    sameSite: 'strict',
    secure: !environment.isDevelopment,
  });
}

export function removeAccessExpirationCookie() {
  return Cookies.remove(ACCESS_COOKIE_EXPIRATION);
}

export function removeAccessCookie() {
  Cookies.remove(ACCESS_COOKIE_EXPIRATION);
  Cookies.remove(ACCESS_COOKIE);
}

export function removeTwoFactorAuthLinkCookie() {
  return Cookies.remove(TWO_FACTOR_LINK_TOKEN);
}

export function refreshAuthCookies() {
  // These cookies are used internally by ember_simple_auth and are not being used for session expiration check
  let currentEmberSimpleAuthSessionCookie = Cookies.get(EMBER_SIMPLE_AUTH_SESSION_COOKIE);
  if (currentEmberSimpleAuthSessionCookie) {
    Cookies.set(EMBER_SIMPLE_AUTH_SESSION_COOKIE, currentEmberSimpleAuthSessionCookie, {
      expires: AUTH_COOKIE_EXPIRES_IN_DAYS,
      sameSite: 'strict',
      secure: !environment.isDevelopment,
    });
  }
}
